import React, {Component} from "react";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";
import { Modal, Button } from "react-bootstrap";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

const propTypes = {
        "buttonText": PropTypes.string,
        "className": PropTypes.string,
        "fileName": PropTypes.string.isRequired,
        "id": PropTypes.string
    },

    defaultProps = {
        "id": "button-download-as-xlsx",
        "className": "button-download",
        "buttonText": "Download"
    };

export default class DownloadOption extends Component {

    constructor (props) {

        super(props);
    }

    handleDownload = () => {

        fetch(
            `/api/Download/${this.props.action}`,
            {
                "method": "post",
                "headers": {
                    "Content-Type": "application/json"
                },
                "body": JSON.stringify({
                    "columnNames": this.props.columns.map((c) => c.text),
                    "fileName": this.props.fileName,
                    "tableData": this.props.ExcelData,
                    "AdditionalInfo": this.props.AdditionalExcelRow ?? null,
                    "CurrencySymbol": this.props.currencySymbol ?? null,
                    "ShowDecimal": this.props.showDecimal ?? null
                })
            }
        ).
            then((response) => response.blob()).
            then((blob) => {

                const url = window.URL.createObjectURL(blob),
                    a = document.createElement("a");
                a.href = url;
                a.download = `${this.props.fileName}.xlsx`;
                a.click();
                a.remove();

            });

    }

    

    render() {
        
        const columns = this.props.columns.map(i => ({
            key: i.dataField,
            label: i.text
        })),
            popover =
            (<Popover>
                    <Popover.Body>
                    <div style={{padding: "0 10px"}}>
                    <h6 className="text-center">{this.props.tooltip}</h6>
                    <Button variant="outline-secondary" className="mr-2 buttonText" onClick={this.handleDownload}>
                        Excel
                    </Button>
                    <CSVLink
                            data={this.props.CSVData}
                                headers={columns}
                            filename={this.props.fileName + ".csv"}
                            target="_blank"
                    >
                            <Button variant="outline-secondary" className="mr-2 buttonText">
                            CSV
                        </Button>

                    </CSVLink>
                        </div>
                </Popover.Body>
            </Popover>)
            ;

        return (
            <>
                <OverlayTrigger
                    key="downloadoption"
                    overlay={popover}
                    placement="bottom"
                    trigger="click"
                    popperConfig={{
                        modifiers: {
                            preventOverflow: {
                                enabled: true
                            }
                        }
                    }}
                    rootClose
                    rootCloseEvent="mousedown"
                >
                    {this.props.extarnalProp ? 
                        this.props.extarnalProp
                        :
                    <i
                        className="material-icons download"
                        id={this.props.id}
                        title={this.props.tooltip}
                    >
                        get_app
                    </i>}
                </OverlayTrigger>
            
            </>
        );

    }

}

DownloadOption.propTypes = propTypes;
DownloadOption.defaultProps = defaultProps;
